import { ServerConfig } from "@/config/config";

export class TicketMessageAttachement {
	id:number;
	messageId:number;
	attachementUrl:string;
	fileName:string;
	mimeType:string;

	constructor(data:any) {
		this.id = data.id;
		this.messageId = data.id;
		this.attachementUrl = `${ServerConfig.host}/files/${data.attachementKey}/${data.fileName}`;
		this.fileName = data.fileName;
		this.mimeType = data.mimeType;
	}

	isImage():boolean {
		return this.mimeType.indexOf("image") != -1;
	}

	getEncodedUrl():string {
		return encodeURI(this.attachementUrl);
	}
}